module.exports = __webpack_public_path__ + "img/report.54d045be.png";